import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
    ExcelExportButton,
} from '@/components/ui/data-table-customized'
import { useDepartmentList } from '../../hooks/use-department-list'

/**
 * Department List Component
 * Render-only component, all logic in useDepartmentList hook
 */
const DepartmentList = () => {
    const {
        departments,
        pagination,
        stateComponent,
        control,
        setFilter,
        columns,
        actions,
        filterItems,
        params,
        queryParams,
        searchInputProps,
        DEPARTMENT_EXCEL_COLUMNS,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useDepartmentList()

    return (
        <Paper className="space-y-2" data-tour="department-table">
            {/* Filters */}
            <div data-tour="department-filters">
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />
            </div>

            {/* Table */}
            {stateComponent || (
                <div data-tour="department-data-table">
                    <DataTableCustomized
                        columns={columns}
                        rows={departments}
                        rowKey={(row) => row.department_id}
                        resizable
                        size="small"
                        actions={actions}
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search_department'),
                            },
                            settings: {
                                show: true,
                                storageKey: 'department-list',
                                actionComponents: [
                                    <ExcelExportButton
                                        key="export"
                                        apiEndpoint="departments"
                                        columns={DEPARTMENT_EXCEL_COLUMNS}
                                        queryParams={queryParams}
                                        feature="department"
                                    />,
                                ],
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                </div>
            )}
        </Paper>
    )
}

export default DepartmentList
